// @flow
import BaseComponent from '../../base_component/base_component';
import {deferrablePost} from '../../../assets/javascripts/offline_handler';

export default class DownloadDocuments extends BaseComponent {
    save() {
        let selectedProducts = $('input[type="checkbox"][data-type="product"]:checked')
            .map((i, e) => `${$(e).data('id')}`).get();
        let availableProducts = $('input[type="checkbox"][data-type="product"]')
            .map((i, e) => `${$(e).data('id')}`).get();

        let updateData = {
            'available_products': availableProducts,
            'selected_products': selectedProducts
        }
        let headers: any = { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') };

        this.find('.title').hide();
        this.find('.fa-spinner').show();

        deferrablePost('/update_cris', updateData, headers).then(deferred => {
            setTimeout(() => {
                this.find('.fa-spinner').hide();
                this.find('.title').show();
            }, deferred ? 200 : 0);
        });
    }
}
